<template>
  <Menu as="div" class="relative">
    <MenuButton class="flex items-center text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500">
      <div class="h-8 w-8 rounded-full bg-primary-100 flex items-center justify-center">
        <span class="text-primary-600 font-medium text-sm">
          {{ userInitials }}
        </span>
      </div>
    </MenuButton>

    <transition
      enter-active-class="transition ease-out duration-100"
      enter-from-class="transform opacity-0 scale-95"
      enter-to-class="transform opacity-100 scale-100"
      leave-active-class="transition ease-in duration-75"
      leave-from-class="transform opacity-100 scale-100"
      leave-to-class="transform opacity-0 scale-95"
    >
      <MenuItems class="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
        <!-- User Info -->
        <div class="px-4 py-3 border-b border-gray-100">
          <p class="text-sm font-medium text-gray-900 truncate">
            {{ authStore.userName || 'ゲスト' }}
          </p>
          <p class="text-xs text-gray-500 truncate">
            {{ authStore.userEmail || '' }}
          </p>
          <div class="mt-1">
            <span
              v-if="authStore.userType"
              :class="[
                'inline-flex items-center px-2 py-0.5 rounded text-xs font-medium',
                authStore.userType === 'individual'
                  ? 'bg-blue-100 text-blue-800'
                  : authStore.userType === 'corporate'
                  ? 'bg-purple-100 text-purple-800'
                  : authStore.userType === 'data_provider'
                  ? 'bg-green-100 text-green-800'
                  : 'bg-gray-100 text-gray-800'
              ]"
            >
              {{ getUserTypeLabel(authStore.userType) }}
            </span>
            <span
              v-if="authStore.isAdmin"
              class="ml-1 inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-red-100 text-red-800"
            >
              管理者
            </span>
          </div>
        </div>

        <!-- Menu Items -->
        <MenuItem v-slot="{ active }">
          <router-link
            to="/profile"
            :class="[
              active ? 'bg-gray-100' : '',
              'flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100'
            ]"
          >
            プロフィール
          </router-link>
        </MenuItem>

        <MenuItem v-slot="{ active }">
          <router-link
            to="/api-keys"
            :class="[
              active ? 'bg-gray-100' : '',
              'flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100'
            ]"
          >
            API キー
          </router-link>
        </MenuItem>

        <MenuItem v-slot="{ active }">
          <router-link
            to="/billing"
            :class="[
              active ? 'bg-gray-100' : '',
              'flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100'
            ]"
          >
            請求・支払い
          </router-link>
        </MenuItem>

        <MenuItem v-slot="{ active }">
          <router-link
            to="/docs/api"
            target="_blank"
            :class="[
              active ? 'bg-gray-100' : '',
              'flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100'
            ]"
          >
            API ドキュメント
          </router-link>
        </MenuItem>

        <div class="border-t border-gray-100 my-1"></div>

        <MenuItem v-slot="{ active }">
          <button
            :class="[
              active ? 'bg-gray-100' : '',
              'flex w-full items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100'
            ]"
            @click="handleLogout"
          >
            ログアウト
          </button>
        </MenuItem>
      </MenuItems>
    </transition>
  </Menu>
</template>

<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue'
import { useAuthStore } from '../../stores/auth.js'

const router = useRouter()
const authStore = useAuthStore()

const userInitials = computed(() => {
  const name = authStore.userName
  if (!name) return 'U'
  return name.split(' ').map(part => part[0]).join('').toUpperCase().slice(0, 2)
})

const getUserTypeLabel = (type) => {
  const labels = {
    trial: 'トライアル',
    individual: '個人',
    corporate: '法人',
    data_provider: 'プロバイダー',
    platform_admin: '管理者'
  }
  return labels[type] || type
}

const handleLogout = async () => {
  try {
    await authStore.logout()
    router.push('/auth/login')
  } catch (error) {
    console.error('Logout error:', error)
    // Force logout even if API call fails
    authStore.clearAuth()
    router.push('/auth/login')
  }
}
</script>
